import {useState} from 'react';
import { useReactTable, flexRender, getCoreRowModel, getPaginationRowModel, } from "@tanstack/react-table";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
//import TablePagination from '@mui/material/TablePagination';



const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.grey.C400,
      color: theme.palette.common.black,
      fontSize: '14px',
      fontFamily: 'helvetica',
      fontWeight: 600,
      paddingBottom:'1rem',
      border: '1px solid',
    
      },
  [`&.${tableCellClasses.body}`]: {
    
      color: theme.palette.common.black,  
      fontSize: '12px',
      fontFamily: 'helvetica',
      padding: theme.spacing(1),
      fontWeight: '400',
      border: '1px solid',
      },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.grey.C50,
      },
        // hide last border
    '&:last-child td, &:last-child th': {
        order: 0,
  },
  }));


export default function TableComp({ columns, data }) {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
 
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10, autoResetPageIndex: true, })

  const [columnResizeMode, setColumnResizeMode] = useState('onChange')
  const [columnResizeDirection, setColumnResizeDirection] = useState('ltr')
  
  const table = useReactTable({ data, columns, 
                                state: {pagination, },
                                columnResizeMode,
                                columnResizeDirection,
                                onPaginationChange: setPagination, 
                                getCoreRowModel: getCoreRowModel(), 
                                getPaginationRowModel: getPaginationRowModel(), 
                                })


return(
<>
  
<Paper sx={{ width: '100%', overflow: 'hidden' }}>
  <TableContainer sx={{bgcolor: 'grey.C050'}}>
    <Table size="small" stickyHeader>
  
    <TableHead >
      {table?.getHeaderGroups()?.map((headerGroup) => {
        return (
          
          <StyledTableRow key={headerGroup?.id}>
            
            {headerGroup?.headers?.map((header) => {
              return (
            
                <StyledTableCell colSpan={header?.colSpan} key={header?.id} align="center">
            
                  {header?.isPlaceholder
                    ? null
                    : flexRender(
                        header?.column?.columnDef?.header,
                        header?.getContext()
                      )}
            
                </StyledTableCell>
              );
            })}
          </StyledTableRow>
        );
      })}
    </TableHead>
    
    {isLoading ? (
      <p>Loading ...</p>
    ) : (
      <TableBody >

      {table?.getCoreRowModel()?.rows.map((row) => (           

                <StyledTableRow key={row.id} >
        
                    {row.getVisibleCells().map((cell) => {
            
                      return  (
                      
                            <StyledTableCell key={cell.id} align="center">
                                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </StyledTableCell>
                          )
                          
                    })}
        
                </StyledTableRow>
            
              ))}
      </TableBody>
    )}

</Table>
</TableContainer>
</Paper>

</>
)}
